export class ClassEnrolment {
  RegistrationId?: string | null;
  CourseName?: string;
  CourseId?: string;
  PersonId?: string;
  EmailAddress: string;
  FirstName: string;
  LastName: string;
  Phone: string;
  WorkCompleted?: boolean;
  CourseFee?: boolean;
  AdminWorkCompleted?: boolean;
  Eligibility?: boolean;
  MessageForLearner?: string;
  EnrolmentStatus?: EnrolmentStatus;
  UpdatedBy?: string;
  LastUpdatedDate?: Date;
  CreatedBy?: string;
  CreatedDate?: Date;
  BirthYear?: string;
  Address?: string;
  NoteToProvider?: string;
  OptInForEmail?: boolean;
  OptInForText?: boolean;
  EnrolmentType?: EnrolmentType;
  EnrolmentRequestType?: string;
  EnrolmentRequestFor?: string;
  EmployeeName?: string;
  ProgramName?: string;
  ProgramNameFr?: string;
  TrainingProviderName?: string;
  IsPrimary?: boolean;
  IsPrimaryLearner?: boolean;
  EnrolmentGroupId?: string;
  LearnerOrder?: string;
  CompletedOn?: Date;
  CompletedOnLocal?: string;
  SubmittedOn?: Date;
  isInfoIncomplete?:boolean;
  WorkerDisplayId?: string;
}

export enum EnrolmentStatus {
  EnrolmentStatusPending = 0,
  EnrolmentStatusConfirmed = 1,
  EnrolmentStatusCanceled = -1,
  EnrolmentStatusCompleted = 2
}

export enum EnrolmentType {
  Worker = 0,
  TrainingProvider = 1,
}

export class BulkCourseEnrolmentStatusUpdate {
  GroupOrRegistrationIds?: string[];
  EnrolmentStatus?: EnrolmentStatus;
  EnrolmentType?: EnrolmentType;
}

export class EnrolmentOption {
  RequestType: '1' | '2';
  RequestFor: '1' | '2';
  Seats: number;
}

export enum EnrollmentFlowType {
  EnrolledView = 0,
  EnrolledEdit = 1,
  PendingView = 2,
  PendingEdit = 3,
  EnrolledEditForPrimaryContact = 4,
  EnrolledEditForLearner = 5,
}
